import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './css/custom.css'

// load custom components
import DisplayNode from './components/DisplayNode'
import DisplayChannelCollection from './components/DisplayChannelCollection'
import FormSchema from './components/FormSchema'
import ChannelForm from './components/ChannelForm'
// import DisplayChannel from './components/DisplayChannel.vue'

// load custom plugins
import Plugins from './plugins'

import App from './components/App'

import store from './store'

// install Element-UI
Vue.use(Vuetify, {
  theme: {
    primary: '#70ace8'
  }
})

// install plugins
Vue.use(Plugins)

// install globally cutom components
Vue.component('display-node', DisplayNode)
Vue.component('display-channel-collection', DisplayChannelCollection)
Vue.component('form-schema', FormSchema)
Vue.component('channel-form', ChannelForm)

new Vue({
  el: '#app',
  store,
  render: h => h(App)
})

// prevent back page action which would result in loosing work done on meteor.
history.pushState(null, null, location.href)
window.onpopstate = function () {
    history.go(1)
}
window.onbeforeunload = function(ev) {
  let msg = 'Are you sure you want to leave ? All your work will be lost !'
  ev.returnValue = msg
  return msg
}
